import React, { useEffect, useState } from 'react';
import * as yup from "yup";
import { NotificationContainer, NotificationManager } from "react-notifications";
import { Formik } from 'formik';
import { Form, Modal, Table, Tab, Tabs } from "react-bootstrap";
import { getQueryPostDto, getQueryGetDto } from '../ServiceController';
import { useDispatch, useSelector } from 'react-redux';
import { format } from 'date-fns';

const RitiriModalForm = (props) => {
    const { open, idAccettazione, closeDialog } = props;
    const dispatch = useDispatch();
    const [state, setState] = useState();
    const anagrafica = useSelector(state => state.anagrafica.selectedAnagrafica);

    useEffect(() => {
        if (open) {
            dispatch(getQueryGetDto(`Ritiri/GetInfo/${idAccettazione}`))
                .then(async (result) => {
                    setState(result);
                })
                .catch((error) => {
                    NotificationManager.error("Error fetching data", "Errore");
                    console.error('Error fetching data:', error);
                });
        }
    }, [open, idAccettazione]);

    const handleSubmit = (values) => {
        NotificationManager.listNotify.forEach(n => NotificationManager.remove({ id: n.id }));
        dispatch(getQueryPostDto('Ritiri/Salva', values))
            .then((data) => {
                if (data.isSuccess) {
                    NotificationManager.success(data.message, "Salva");
                    setTimeout(() => {
                        handleClose();
                    }, 500);
                } else {
                    NotificationManager.error(data.message, "Salva");
                }
            }).catch((error) => {
                NotificationManager.error("Error submitting data", "Errore");
                console.error('Error submitting data:', error);
            }).finally(() => {
            });
    }

    const formattaData = (data) => {
        const newData = new Date(data);
        return format(newData, 'dd/MM/yyyy HH:mm:ss')
    }

    const handleClose = () => {
        setState();
        closeDialog();
    }

    const getTitoloTab = (obj) => {
        if (obj.ritirato) {
            var desc = obj.dettaglioEsami.map(item => item.codice).join(', ');
            return `[${desc}]`;
        } else {
            return "Da ritirare";
        }
    }

    return (
        <>
            <Modal size='lg' show={open} centered={true} onHide={handleClose} backdrop="static">
                <Modal.Header className="bg-primary text-white d-flex flex-wrap justify-content-between align-items-center">
                    <h4 className="m-0 text-white">Ritiro Esami</h4>
                    <i className="i-Close-Window cursor-pointer text-18"
                        onClick={handleClose}
                    ></i>
                </Modal.Header>
                <Modal.Body>
                    {state && (
                        <Tabs defaultActiveKey={state.length - 1} id="ritiri-tabs">
                            {state.map((tabData, tabIndex) => (
                                <Tab eventKey={tabIndex} title={getTitoloTab(tabData)} key={tabIndex}>
                                    <Formik
                                        initialValues={tabData}
                                        validationSchema={basicFormSchema}
                                        onSubmit={handleSubmit}
                                        enableReinitialize={true}
                                    >
                                        {({
                                            values,
                                            errors,
                                            touched,
                                            handleChange,
                                            handleBlur,
                                            handleSubmit,
                                            setFieldValue,
                                            isSubmitting
                                        }) => (
                                            <form onSubmit={handleSubmit}>
                                                <div style={{ display: 'flex', justifyContent: 'space-between' }}>
                                                    <div style={{ width: '30%' }}>
                                                        <h4 className='text-center fw-bold'>{values.ritirato ? "Ritirato da: " : "Chi ritira?"}</h4>
                                                        <div className='mt-2'>
                                                            <Form.Check
                                                                type="switch"
                                                                id="ritiro-switch"
                                                                label={values.isDelegato ? "Delegato" : "Paziente"}
                                                                checked={values.isDelegato}
                                                                disabled={values.ritirato}
                                                                onChange={(e) => {
                                                                    setFieldValue("isDelegato", e.target.checked);
                                                                    if (!e.target.checked) {
                                                                        setFieldValue("ritirante", `${anagrafica.nome} ${anagrafica.cognome}`);
                                                                        setFieldValue("numeroDocumento", anagrafica.numeroDocumento);
                                                                        setFieldValue("ruoloDelega", "Paziente");
                                                                    } else {
                                                                        setFieldValue("ritirante", "");
                                                                        setFieldValue("numeroDocumento", "");
                                                                        setFieldValue("ruoloDelega", "");
                                                                    }
                                                                }}
                                                            />
                                                        </div>
                                                        <div className='mt-2'>
                                                            <label htmlFor="ritirante">Ritirante</label>
                                                            <input
                                                                id="ritirante"
                                                                name="ritirante"
                                                                className="form-control"
                                                                placeholder="Nome e Cognome"
                                                                type="text"
                                                                onChange={handleChange}
                                                                onBlur={handleBlur}
                                                                value={values.ritirante}
                                                                readOnly={values.ritirato}
                                                            />
                                                            {errors.ritirante && touched.ritirante && (
                                                                <div className="text-danger mt-1 ml-2">
                                                                    {errors.ritirante}
                                                                </div>
                                                            )}
                                                        </div>
                                                        <div className='mt-2'>
                                                            <label htmlFor="numeroDocumento">Numero Documento</label>
                                                            <input
                                                                id="numeroDocumento"
                                                                name="numeroDocumento"
                                                                className="form-control"
                                                                placeholder="Numero Documento"
                                                                type="text"
                                                                onChange={handleChange}
                                                                onBlur={handleBlur}
                                                                value={values.numeroDocumento}
                                                                readOnly={values.ritirato}
                                                            />
                                                            {errors.numeroDocumento && touched.numeroDocumento && (
                                                                <div className="text-danger mt-1 ml-2">
                                                                    {errors.numeroDocumento}
                                                                </div>
                                                            )}
                                                        </div>
                                                        <div className='mt-2'>
                                                            <label htmlFor="ruoloDelega">Ruolo Delega</label>
                                                            <input
                                                                id="ruoloDelega"
                                                                name="ruoloDelega"
                                                                className="form-control"
                                                                placeholder="Ruolo Delega"
                                                                type="text"
                                                                onChange={handleChange}
                                                                onBlur={handleBlur}
                                                                value={values.ruoloDelega}
                                                                readOnly={!values.isDelegato || values.ritirato}
                                                            />
                                                            {errors.ruoloDelega && touched.ruoloDelega && (
                                                                <div className="text-danger mt-1 ml-2">
                                                                    {errors.ruoloDelega}
                                                                </div>
                                                            )}
                                                        </div>
                                                    </div>
                                                    <div style={{ width: '65%' }}>
                                                        <h4 className='text-center fw-bold'>Esami</h4>
                                                        <Table
                                                            hover
                                                            id="es_table"
                                                            className="table dataTable-collapse text-center"
                                                        >
                                                            <thead className='w-100'>
                                                                <tr>
                                                                    <th scope="col">#</th>
                                                                    {!values.ritirato &&
                                                                        <th scope="col">Sel.</th>
                                                                    }
                                                                    <th style={{ textAlign: 'center' }} scope="col">Esame</th>
                                                                </tr>
                                                            </thead>
                                                            <tbody>
                                                                {values.dettaglioEsami.map((esame, index) => (
                                                                    <tr key={index} >
                                                                        <th scope="row">{index + 1}</th>
                                                                        {
                                                                            !values.ritirato &&
                                                                            <td>
                                                                                <input
                                                                                    type="checkbox"
                                                                                    checked={
                                                                                        values.dettaglioEsami.length === 1
                                                                                            ? true
                                                                                            : values.dettaglioEsami[index].checked
                                                                                    }
                                                                                    disabled={values.dettaglioEsami.length === 1}
                                                                                    onChange={() =>
                                                                                        setFieldValue(
                                                                                            `dettaglioEsami.${index}.checked`,
                                                                                            !values.dettaglioEsami[index].checked
                                                                                        )
                                                                                    }
                                                                                />
                                                                            </td>
                                                                        }
                                                                        <td>{esame.descrizione}</td>
                                                                    </tr>
                                                                ))}
                                                            </tbody>
                                                        </Table>
                                                    </div>
                                                </div>
                                                {values.ritirato &&
                                                    <div className='mt-3 alert alert-success text-center'>
                                                        <h4>Data Ritiro: {formattaData(values.dataRitiro)}</h4>
                                                    </div>
                                                }
                                                <hr />
                                                <div className='row mt-3 px-3 d-flex'>
                                                    <button className='col-3 btn btn-secondary' onClick={handleClose} type="button">Chiudi</button>
                                                    <div className='col-6'></div>
                                                    <button className='col-3 btn btn-primary' disabled={values.ritirato} onClick={handleSubmit} type="button">Salva</button>
                                                </div>
                                            </form>
                                        )}
                                    </Formik>
                                </Tab>
                            ))}
                        </Tabs>
                    )}
                </Modal.Body>
            </Modal>
            <NotificationContainer />
        </>
    );
};

const basicFormSchema = yup.object().shape({
    ritirante: yup.string().required('Campo obbligatorio'),
    numeroDocumento: yup.string().required('Campo obbligatorio'),
    ruoloDelega: yup.string().required('Campo obbligatorio')
});

export default RitiriModalForm;
